<script lang="ts">
	import type { PublicListingEvent } from '$lib/vivenu/types';

	export let event: PublicListingEvent;
	export let hideMeta = false;

	const date = (event.start && new Date(event.start)) || undefined;
	// prettier-ignore
	const monthNames = [ 'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez' ];
	const monthName = date ? monthNames[date.getMonth()] : '';
	const dayText = date ? date.getDate().toString().padStart(2, '0') : '';
</script>

<div class="text-box">
	{#if date && (monthName !== 'Jan' || dayText !== '01')}
		<div class="date">
			<span class="month">{monthName}</span>
			<span class="day">{dayText}</span>
		</div>
	{/if}

	<div class="title">
		{#if event.name}
			<span class="name">
				{event.name}
			</span>
		{/if}

		{#if !hideMeta}
			{#if event.locationName}
				<span class="location">
					{event.locationName}
				</span>
			{/if}

			{#if event.meta?.extra_info_text}
				<strong class="extra">{event.meta?.extra_info_text}</strong>
			{/if}
		{/if}
	</div>
</div>

<style>
	.text-box {
		background-color: #fff;
		display: flex;
		gap: 1rem;
		padding: 1rem;
		flex-grow: 1;
	}

	.date {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.month {
		color: #e01;
		font-weight: bold;
	}

	.day {
		font-weight: bold;
		font-size: x-large;
	}

	.title {
		display: flex;
		flex-direction: column;
	}

	.name {
		font-weight: bold;
	}

	.location {
		opacity: 75%;
	}

	strong {
		opacity: 75%;
	}
</style>
